import { TrendUp, TrendDown } from "@phosphor-icons/react";
import { HxTile } from "./HxBadge";
import { HxSparkline } from "./charts";
import { useCountUp } from "./useCountUp";

/** Denser KPI card: tighter hierarchy, integrated trend chip, animated value. */
export function HxKpi({ tone, icon: Icon, label, value, suffix = "", delta, invert, series, color, meta = "vs previous 7 days", testid }) {
  const numeric = typeof value === "number";
  const counted = useCountUp(numeric ? value : 0, { enabled: numeric });
  const shown = numeric ? `${counted}${suffix}` : value;
  const good = invert ? delta < 0 : delta > 0;
  return (
    <div className="hx-card hx-card--hover hx-kpi" data-testid={testid}>
      <div className="hx-kpi__top">
        <HxTile tone={tone} className="hx-kpi__tile"><Icon size={20} weight="duotone" /></HxTile>
        <div style={{ minWidth: 0, flex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
            <span className="hx-kpi__label">{label}</span>
            {delta != null && Number.isFinite(delta) && (
              <span className={`hx-delta ${delta === 0 ? "hx-delta--flat" : good ? "hx-delta--up" : "hx-delta--down"}`}>
                {delta > 0 ? <TrendUp size={10} weight="bold" /> : delta < 0 ? <TrendDown size={10} weight="bold" /> : null}
                {Math.abs(delta)}%
              </span>
            )}
          </div>
          <div className="hx-kpi__value" data-testid={testid ? `${testid}-value` : undefined}>{shown}</div>
          <div className="hx-kpi__meta">{meta}</div>
        </div>
      </div>
      <HxSparkline data={series} color={color} />
    </div>
  );
}
